import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundStoryKnobs: Knobs = {
  accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  disabled: {
    default: false,
    editor: 'checkbox',
  },
  buttonStyle: {
    editor: 'textbox',
    default: '',
  },
  buttonContentStyle: {
    editor: 'textbox',
    default: '',
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const PlaygroundStoryKnobsReact: Knobs = {
  ...PlaygroundStoryKnobs,
  buttonStyle: {
    ...PlaygroundStoryKnobs.buttonStyle,
    qualifierStart: '{',
    qualifierEnd: '}',
  },
  buttonContentStyle: {
    ...PlaygroundStoryKnobs.buttonContentStyle,
    qualifierStart: '{',
    qualifierEnd: '}',
  },
};

const playgroundStory: Story = {
  title: 'Playground',
  description: 'A square button',
  coreComponent_v3: {
    html: `<tag3-square-button{{...knobs}}>
  <tag3-icon-svg icon='Bug'></tag3-icon-svg>
</tag3-square-button>`,
    knobs: PlaygroundStoryKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3SquareButton{{...knobs}}>
  <Tag3IconSvg icon='Bug'/>
</Tag3SquareButton>`,
    knobs: PlaygroundStoryKnobsReact,
  },
};

export const TagSquareButtonDocs: Component = {
  type: 'component',
  name: 'square-button',
  description: 'Renders a square button',
  mobileFriendly: false,
  preRelease: '',
  popular: true,
  props: [
    {
      name: 'accent',
      description: 'The colour of the button',
      type: 'string',
      default: 'btndefault',
    },
    {
      name: 'type',
      description: 'The type of the button',
      type: 'string',
      default: 'button',
    },
    {
      name: 'disabled',
      description: 'Whether the button is disabled',
      type: 'boolean',
    },
    {
      name: 'buttonStyle',
      description: 'JSX style object in JSON to apply to the button',
      type: 'string',
    },
    {
      name: 'buttonContentStyle',
      description: 'JSX style object in JSON to apply to the content of the button',
      type: 'string',
    },
    {
      name: 'buttonClickInclude',
      description:
        'You can add an id to the button which will be send in the buttonClick event. Data to include in the buttonClick event. Useful for buttons in templated lists when you want to get access to the list item data in the button click handler',
      type: 'string',
    },
    {
      name: 'colour-scheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  methods: [],
  events: [
    {
      name: 'buttonClick',
      description: 'Triggers when the button is clicked',
      parameters: [],
    },
  ],
  stories: [playgroundStory],
};
